<template>
  <div v-if="data">    
    <default-financial-card :chip_icon="'mdi-arrow-down'" :background_color="background_color" :value="data.payed" :title="title" :icon="icon" :title_class="title_class" :icon_color="icon_color">
      <template v-slot:extra>
        {{extra_values_short}}
      </template>
    </default-financial-card>
  </div>
</template>

<script>
export default {
  name: 'Expenditure',

  components: {
    DefaultFinancialCard: () => import ('./DefaultFinancialCard.vue'),
  },

  props: {
    data: {
      type: Object,
    },
  },

  data() {
    return {
      title: 'Saídas',
      icon: 'mdi-cash-minus',
      title_class: 'red--text overline',
      icon_color: 'red',
      background_color: 'rgba(232,38,30,0.2)',
      // value: 4000,
    }
  },
  computed: {
    data_open() {
      if (this.data && this.data.open){
        return (Number(this.data.open)/100).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) 
      }
      return null
    },
    data_overdue() {
      if (this.data && this.data.overdue){
        return (Number(this.data.overdue)/100).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) 
      }
      return null
    },
    extra_values_short(){
      if (this.data){
        let {open, overdue} = this.data
        let val = (open || 0) + (overdue || 0 )
        let msg = ['AP = ']

        if (this.data_open) msg.push(this.data_open) 
        
        if (this.data_overdue) msg.push('+' + this.data_overdue) 
        
        if (!this.data_overdue && !this.data_overdue) msg.push(0)
        
        return (Number(val)/100).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) 
        // return msg.join(' ')
      }
    },
    extra_values_long(){
      if (this.data){
        let msg = ['A Pagar = ']

        if (this.data_open) msg.push(`${this.data_open} ainda este mês`) 
        
        if (this.data_overdue) msg.push('+' + `${this.data_overdue} atrasados`) 
        
        if (!this.data_overdue && !this.data_overdue) msg.push(0)
        
        return msg.join(' ')
      }
    },
  },
}
</script>

<style lang="scss" scoped>

</style>